<div class="sheet-backdrop" [ngClass]="{'show': bottomSheetService.show}" (click)="onBackdrop()"></div>

<div class="sheet" #sheet [ngClass]="{'show': bottomSheetService.show}"
    [style.max-width]="bottomSheetService.maxWidth" [style.max-height]="bottomSheetService.maxHeight">

    <div class="grabber-row" (pointerdown)="startDrag($event)">
        <div class="grabber"></div>
    </div>

    <div class="sheet-header">
        <div class="title">{{ bottomSheetService.sheetTitle }}</div>
        <div class="button square-button close-button" (click)="close()"
            [ngClass]="{'disabled': !(bottomSheetService.closeButtonEnabled$ | async)}">
            <img src="/assets/icons/close.svg" class="icon-white" alt="">
        </div>
    </div>

    <div class="sheet-content">
        <ng-template bottomSheetHost></ng-template>
    </div>

    <div class="sheet-footer"
        *ngIf="bottomSheetService.submitButtonText || bottomSheetService.secondaryButtonText || (bottomSheetService.message$ | async)">
        <div class="message fade-in" *ngIf="(bottomSheetService.message$ | async) as message" [innerHTML]="message"></div>
        <div class="actions">
            <div class="button secondary" *ngIf="bottomSheetService.secondaryButtonText" (click)="secondary()">
                {{ bottomSheetService.secondaryButtonText }}
            </div>
            <div class="button" *ngIf="bottomSheetService.submitButtonText"
                [ngClass]="{'disabled': !(bottomSheetService.submitButtonEnabled$ | async)}" (click)="submit()">
                {{ bottomSheetService.submitButtonText }}
            </div>
        </div>
    </div>
</div>
